import React, { Component } from 'react';
import SecureLayout from '../../../templates/secure';
import {NavLink} from 'react-router-dom';
import _ from 'lodash';

class UsersAdd extends Component{
	render(){
		const {users} =this.props;
		let uc = _.find(users.permissions, (o) => {return o==='Create'});
		return (
			uc ?
				<p>
					<NavLink to={`/usuarios/crear`} className="button is-small is-inm-purple">{'Agregar Usuario'}</NavLink>
				</p>
				:''
		)
	}
}

export default SecureLayout(UsersAdd);


// WEBPACK FOOTER //
// ./src/elements/users/widget/users_add.jsx